<template>
  <div>
    <base-header class="pb-4" />

    <div class="container-fluid mt--4 pt-5 income-forms">
      <b-row>
        <b-col>
          <b-form-group :label="type && type=='income' ? 'Gelir Tarihi' : 'Gider Tarihi'">
            <b-form-input v-model="expense.date" type="date" />
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Kategori">
            <b-form-select v-model="expense.category_id" :options="categories" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Fiyat">
            <b-form-input v-model="expense.price" type="number" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Açıklama">
            <b-form-input v-model="expense.description" type="text" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="text-right">
          <b-button @click="hideModal()" variant="secondary">İptal</b-button>
          <b-button variant="primary" class="loading-button" @click="type=='expense' ? saveExpense() : saveIncome()" :disabled="$v.$invalid || loadingButton">
            <i v-if="loadingButton" class="fa fa-spinner"></i> Kaydet</b-button>
        </b-col>
      </b-row>
    </div>

  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { required } from 'vuelidate/lib/validators'
  export default {
    name: 'ExpenseModal',
    props: ['show', 'categories', 'clientId','type'],
    data() {
      return {
        loadingButton: false,
        expense: {},
      }
    },
    methods: {
      ...mapActions(['updateExpense', 'createExpense','createIncome','updateIncome']),
      saveExpense() {
        this.loadingButton = true;
        // create
        this.createExpense({
          ...this.expense,
          type:this.type,
          client_id: this.clientId,
        }).then(() => {
          this.loadingButton = false;
          this.$emit('refresh-table');
          this.$refs.expenseModal.hide();
        }).catch(error => {
          this.loadingButton = false;
          this.error(error.response.data.message);
        });
      },
      saveIncome() {
        this.loadingButton = true;
        // create
        this.createIncome({
          ...this.expense,
          payment_type:'cash',
          type:this.type,
          client_id: this.clientId,
        }).then(() => {
          this.loadingButton = false;
          this.$emit('refresh-table');
          this.$refs.expenseModal.hide();
        }).catch(error => {
          this.loadingButton = false;
          this.error(error.response.data.message);
        });
      },
      hideModal() {
        this.$emit('hide');
      }
    },
    validations() {
      const data = {};
      data.expense = {};
      data.expense.date = { required };
      data.expense.category_id = { required }
      data.expense.price = { required }
      return data;
    },
  }
</script>
